import { render, staticRenderFns } from "./ConfirmMessageButton.vue?vue&type=template&id=2caf4008"
import script from "./ConfirmMessageButton.vue?vue&type=script&lang=js"
export * from "./ConfirmMessageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports